

class Styles
{
    static DefaultDate = 'html-date'
    static DefaultNumber = 'number'
    static DefaultCombo = 'select'
}

export default Styles;